import L from "leaflet";
import "proj4leaflet";
import {dataforvalterMapConfig} from "./map-config";

export const LEAFLET_EPSG25833_GEODATA = new L.Proj.CRS('EPSG:25833', dataforvalterMapConfig.projections.EPSG25833,
    {
        origin: [-2500000.0, 9045984.0],
        resolutions: [
            21674.7100160867,
            10837.35500804335,
            5418.677504021675,
            2709.3387520108377,
            1354.6693760054188,
            677.3346880027094,
            338.6673440013547,
            169.33367200067735,
            84.66683600033868,
            42.33341800016934,
            21.16670900008467,
            10.583354500042335,
            5.291677250021167,
            2.6458386250105836,
            1.3229193125052918,
            0.6614596562526459,
            0.33072982812632296,
            0.16536491406316148,
            0.08268245703158074,
            0.04134122851579037,
            0.020670614257895185
        ]
    });

export const LEAFLET_EPSG25833_NIB = new L.Proj.CRS('EPSG:25833', dataforvalterMapConfig.projections.EPSG25833,
    {
        origin: [-2500000.0, 9045984.0],
        resolutions: [
            21664,
            10832,
            5416,
            2708,
            1354,
            677,
            338.5,
            169.25,
            84.625,
            42.3125,
            21.15625,
            10.578125,
            5.2890625,
            2.64453125,
            1.322265625,
            0.6611328125,
            0.33056640625,
            0.165283203125
        ]
    });
